import {
  type PimProductV11,
  PimProductV1StockStatusEnum,
} from '@redteclab/api/clients/bully'

export const productAccessorStockStatusIsFreebie = (
  product: PimProductV11,
): boolean => {
  return product.stock_status === PimProductV1StockStatusEnum.Free
}
